import { render, staticRenderFns } from "./DashboardBusStatus.vue?vue&type=template&id=0ecab29c&scoped=true&"
import script from "./DashboardBusStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardBusStatus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBusStatus.vue?vue&type=style&index=0&id=0ecab29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecab29c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VProgressCircular,VRow})
